import React from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import AccordionOneColumn from '../AccordionOneColumn';

const AccordionsTwoColumns = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const leftQuestions = filteredQuestions.filter(
    (item, index) => index % 2 === 0,
  );
  const rightQuestions = filteredQuestions.filter(
    (item, index) => index % 2 === 1,
  );
  return (
    <>
      <AccordionOneColumn filteredQuestions={leftQuestions} />
      <AccordionOneColumn filteredQuestions={rightQuestions} />
    </>
  );
};

export default AccordionsTwoColumns;
